import { useGetCustomerCartIdQuery, useGetCustomerCartOrderPricesQuery } from "@jti/store/slices/magentoApiSlice";

export const useCartPrices = () => {
  const standardCartIdQueryState = useGetCustomerCartIdQuery();
  const cartId = standardCartIdQueryState.data?.customerCart?.id;

  const cartPricesQueryState = useGetCustomerCartOrderPricesQuery(cartId!, {
    skip: !cartId,
  });

  return {
    data: cartPricesQueryState.data,
    isLoading: cartPricesQueryState.isLoading || cartPricesQueryState.isFetching,
    isSuccess: cartPricesQueryState.isSuccess,
    isError: cartPricesQueryState.isError,
    error: cartPricesQueryState.error,
    isUninitialized: cartPricesQueryState.isUninitialized,
  };
};
